'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FinderActionsDropdown from 'DesignFinderUI/components/actions/FinderActionsDropdown';
import NewActionsList from 'DesignFinderUI/components/actions/NewActionsList';
import withNewFileWizard from 'DesignFinderUI/components/modals/hoc/withNewFileWizard';
import withNewThemeWizard from 'DesignFinderUI/components/modals/hoc/withNewThemeWizard';
import withNewFunctionWizard from 'DesignFinderUI/components/modals/hoc/withNewFunctionWizard';
import withNewProjectWizard from 'DesignFinderUI/components/modals/hoc/withNewProjectWizard';
import withDeployFunctionWizard from 'DesignFinderUI/components/modals/hoc/withDeployFunctionWizard';
import withDeployProjectWizard from 'DesignFinderUI/components/modals/hoc/withDeployProjectWizard';
import NewFolderStep from 'DesignFinderUI/components/onboarding/NewFolderStep';

const i18nKey = key => `DesignFinderUI.actions.NewActionsDropdown.${key}`;

class NewActionsDropdown extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      open: false,
      use: 'list'
    };

    this.handleClose = () => {
      this.setState({
        open: false,
        use: 'list'
      });
    };

    this.handleOpenChange = evt => {
      const {
        value: open
      } = evt.target;

      if (open !== this.state.open) {
        this.setState({
          open,
          use: open ? 'list' : 'unstyled'
        });
      }
    };

    this.handleNewAssetFormShown = shown => {
      this.setState({
        use: shown ? 'unstyled' : 'list'
      });
    };
  }

  render() {
    const _this$props = this.props,
          {
      NewFileWizard: renderedNewFileWizard,
      NewThemeWizard: renderedNewThemeWizard,
      NewFunctionWizard: renderedNewFunctionWizard,
      NewProjectWizard: renderedNewProjectWizard,
      DeployFunctionWizard: renderedDeployFunctionWizard,
      DeployProjectWizard: renderedDeployProjectWizard,
      canCreateFile,
      canCreateFolder,
      disabled
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["NewFileWizard", "NewThemeWizard", "NewFunctionWizard", "NewProjectWizard", "DeployFunctionWizard", "DeployProjectWizard", "canCreateFile", "canCreateFolder", "disabled"]);

    const {
      open,
      use
    } = this.state;
    const canCreate = canCreateFile || canCreateFolder;

    const renderedActions = /*#__PURE__*/_jsx(NewActionsList, Object.assign({}, rest, {
      onClose: this.handleClose,
      onNewAssetFormShown: this.handleNewAssetFormShown,
      open: open,
      canCreate: canCreate
    }));

    const renderedButtonText = /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('buttonText')
      })
    });

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(NewFolderStep, {
        children: /*#__PURE__*/_jsx(FinderActionsDropdown, {
          buttonText: renderedButtonText,
          closeOnMenuClick: false,
          "data-test-id": this.props['data-test-id'] || '',
          disabled: disabled,
          onOpenChange: this.handleOpenChange,
          open: open,
          use: use,
          children: renderedActions
        })
      }), renderedNewFileWizard, renderedNewThemeWizard, renderedNewFunctionWizard, renderedNewProjectWizard, renderedDeployFunctionWizard, renderedDeployProjectWizard]
    });
  }

}

NewActionsDropdown.propTypes = {
  NewFileWizard: PropTypes.node,
  NewThemeWizard: PropTypes.node,
  NewFunctionWizard: PropTypes.node,
  NewProjectWizard: PropTypes.node,
  DeployFunctionWizard: PropTypes.node,
  DeployProjectWizard: PropTypes.node,
  canCreateFile: PropTypes.bool,
  canCreateFolder: PropTypes.bool,
  disabled: PropTypes.bool,
  'data-test-id': PropTypes.any
};
NewActionsDropdown.defaultProps = {
  NewFileWizard: null,
  NewThemeWizard: null,
  NewFunctionWizard: null,
  NewProjectWizard: null,
  DeployFunctionWizard: null,
  DeployProjectWizard: null,
  canCreateFile: false,
  canCreateFolder: false,
  canCreateTheme: false,
  disabled: false
};
export default compose(withNewFileWizard, withNewThemeWizard, withNewFunctionWizard, withNewProjectWizard, withDeployFunctionWizard, withDeployProjectWizard)(NewActionsDropdown);